import InboxRulesOption from 'owa-inbox-rules-option/lib/InboxRulesOption';
import { OptionSubCategory } from 'owa-options-core';

let rulesSubCategory: OptionSubCategory = {
    key: 'rules',
    titleStringKey: 'optionSubcategory_rules',
    options: [InboxRulesOption],
};

export default rulesSubCategory;
